var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2295,
    cy: 9.9102,
    r: 9.66362,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9566 13.7095L11.2427 13.886C10.772 14.6043 10.3864 15.0629 10.0861 15.2618C9.78986 15.4607 9.4936 15.5601 9.19734 15.5601C8.61294 15.5601 8.32074 15.2821 8.32074 14.7261C8.32074 14.5394 8.3877 14.2026 8.52162 13.7156L9.14255 11.4145C9.24401 11.0533 9.29474 10.8301 9.29474 10.7449C9.29474 10.4811 9.07762 10.3492 8.64338 10.3492H8.55815V10.0144C9.57274 9.9413 10.4128 9.82158 11.0784 9.65519L9.97045 13.7095C9.869 14.0747 9.81827 14.3385 9.81827 14.5009C9.81827 14.5577 9.83653 14.6043 9.87305 14.6409C9.90958 14.6774 9.95828 14.6957 10.0192 14.6957C10.214 14.6957 10.5264 14.3669 10.9566 13.7095ZM9.8487 7.73762C9.8487 7.5063 9.92784 7.30947 10.0861 7.14713C10.2485 6.9848 10.4473 6.90363 10.6827 6.90363C10.914 6.90363 11.1129 6.98683 11.2793 7.15322C11.4497 7.31556 11.5349 7.51441 11.5349 7.7498C11.5349 7.96083 11.4578 8.1536 11.3036 8.32811C11.1494 8.49856 10.9303 8.58379 10.6462 8.58379C10.4798 8.58379 10.3053 8.51074 10.1226 8.36464C9.94002 8.21854 9.8487 8.00953 9.8487 7.73762Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/infoCircle.188160e5cb0c1fe726059c867444b689.svg";
export { ForwardRef as ReactComponent };